"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOfferUnderContractSubjectBuildingInspectionDto = instanceOfOfferUnderContractSubjectBuildingInspectionDto;
exports.OfferUnderContractSubjectBuildingInspectionDtoFromJSON = OfferUnderContractSubjectBuildingInspectionDtoFromJSON;
exports.OfferUnderContractSubjectBuildingInspectionDtoFromJSONTyped = OfferUnderContractSubjectBuildingInspectionDtoFromJSONTyped;
exports.OfferUnderContractSubjectBuildingInspectionDtoToJSON = OfferUnderContractSubjectBuildingInspectionDtoToJSON;
exports.OfferUnderContractSubjectBuildingInspectionDtoToJSONTyped = OfferUnderContractSubjectBuildingInspectionDtoToJSONTyped;
/**
 * Check if a given object implements the OfferUnderContractSubjectBuildingInspectionDto interface.
 */
function instanceOfOfferUnderContractSubjectBuildingInspectionDto(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('date' in value) || value['date'] === undefined)
        return false;
    return true;
}
function OfferUnderContractSubjectBuildingInspectionDtoFromJSON(json) {
    return OfferUnderContractSubjectBuildingInspectionDtoFromJSONTyped(json, false);
}
function OfferUnderContractSubjectBuildingInspectionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'date': json['date'],
    };
}
function OfferUnderContractSubjectBuildingInspectionDtoToJSON(json) {
    return OfferUnderContractSubjectBuildingInspectionDtoToJSONTyped(json, false);
}
function OfferUnderContractSubjectBuildingInspectionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'date': value['date'],
    };
}
